import { BookOpen, Building, Truck, Users } from "lucide-react";
import { useGetIdentity, useTranslate } from "ra-core";
import { ToggleFilterButton } from "@/components/admin/toggle-filter-button";
import { useIsMobile } from "@/hooks/use-mobile";

import { FilterCategory } from "../filters/FilterCategory";
import { ResponsiveFilters } from "../misc/ResponsiveFilters";
import { useConfigurationContext } from "../root/ConfigurationContext";
import { AccountManagerFilter } from "../sales/AccountManagerInput";
import { getTranslatedCompanySizeLabel } from "./getTranslatedCompanySizeLabel";
import { sizes } from "./sizes";

export const CompanyListFilter = () => {
  const isMobile = useIsMobile();
  const { identity } = useGetIdentity();
  const { companySectors, revistas } = useConfigurationContext();
  const translate = useTranslate();
  const translatedSizes = sizes.map((size) => ({
    ...size,
    name: getTranslatedCompanySizeLabel(size, translate),
  }));

  return (
    <ResponsiveFilters
      searchInput={
        isMobile
          ? undefined
          : { placeholder: translate("resources.companies.fields.name") }
      }
    >
      <FilterCategory
        icon={<Building className="h-4 w-4" />}
        label="resources.companies.fields.size"
      >
        {translatedSizes.map((size) => (
          <ToggleFilterButton
            className="w-auto md:w-full justify-between h-10 md:h-8"
            label={size.name}
            key={size.name}
            value={{ size: size.id }}
            size={isMobile ? "lg" : undefined}
          />
        ))}
      </FilterCategory>

      <FilterCategory
        icon={<Truck className="h-4 w-4" />}
        label="resources.companies.fields.ramos"
      >
        {companySectors.map((sector) => (
          <ToggleFilterButton
            className="w-auto md:w-full justify-between h-10 md:h-8"
            label={sector.label}
            key={sector.value}
            value={{ "ramos@cs": `{${sector.value}}` }}
            size={isMobile ? "lg" : undefined}
          />
        ))}
      </FilterCategory>

      <FilterCategory
        icon={<BookOpen className="h-4 w-4" />}
        label="resources.companies.fields.revistas"
      >
        {revistas.map((revista) => (
          <ToggleFilterButton
            className="w-auto md:w-full justify-between h-10 md:h-8"
            label={revista.label}
            key={revista.value}
            value={{ "revistas@cs": `{${revista.value}}` }}
            size={isMobile ? "lg" : undefined}
          />
        ))}
      </FilterCategory>

      <FilterCategory
        icon={<Users className="h-4 w-4" />}
        label="resources.companies.fields.sales_id"
      >
        <ToggleFilterButton
          className="w-auto md:w-full max-w-full justify-between h-10 md:h-8"
          label={translate("crm.common.me")}
          value={{ sales_id: identity?.id }}
          size={isMobile ? "lg" : undefined}
        />
        <AccountManagerFilter
          className="w-auto md:w-full max-w-full justify-between h-10 md:h-8"
          size={isMobile ? "lg" : undefined}
        />
      </FilterCategory>
    </ResponsiveFilters>
  );
};
